// src/utils/auth.js
import axios from "axios";

// 로그인 API 호출 함수
export const loginUser = async (username, password) => {
  try {
    const response = await axios.post("http://35.192.131.111/user/login/", {
      username,
      password,
    });
    if (response.data.result) {
      const { access, refresh, user_id } = response.data.data;
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      localStorage.setItem("user_id", user_id);
      localStorage.setItem("username", username);
      return { success: true };
    }
  } catch (error) {
    console.error("Login failed:", error);
    return { success: false, message: "로그인 실패" };
  }
};

// 토큰 갱신 함수
export const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    const response = await axios.post(
      "http://35.192.131.111/user/token/refresh",
      {
        refresh: refreshToken,
      }
    );
    if (response.data.result) {
      const newAccessToken = response.data.data.access;
      localStorage.setItem("access_token", newAccessToken);
      return newAccessToken;
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }
  return null;
};

// 인증 요청을 위한 Axios 설정
export const authRequest = async (url, options) => {
  let token = localStorage.getItem("access_token");
  try {
    const response = await axios({
      ...options,
      url,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    // 토큰 만료 시 갱신 시도
    if (error.response && error.response.status === 401) {
      const newToken = await refreshAccessToken();
      if (newToken) {
        // 새로운 토큰으로 재요청
        return axios({
          ...options,
          url,
          headers: {
            ...options.headers,
            Authorization: `Bearer ${newToken}`,
          },
        });
      }
    }
    throw error;
  }
};
